import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=46a45f1c&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a45f1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46a45f1c')) {
      api.createRecord('46a45f1c', component.options)
    } else {
      api.reload('46a45f1c', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=46a45f1c&scoped=true&", function () {
      api.rerender('46a45f1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ujazRDjZaHke/JS/comp/SearchFilterTokens.vue"
export default component.exports